<template>
    <div class="institutionalaccreditation">
        <div class="MainContent">
            <p class="title">机构认证</p>
            <div class="item">
                <p class="mintitle">机构信息</p>
                <div class="content">
                    <div class="minitem">
                        <span class="label">机构名称</span>
                        <el-input v-model="params.orgName" placeholder="请输入机构名称" class="autowidth" clearable maxlength="30" show-word-limit></el-input>
                    </div>
                    <div class="minitem" style="display: flex;">
                        <span class="label">机构logo</span>
                        <el-upload class="avatar-uploader" :action="actionUrl" 
                        :headers="{Authorization:Authorization}"
                        :show-file-list="false" v-loading="logoing" :on-success="handleLogoSuccess" name="images" accept="image/jpeg,image/gif,image/png" :before-upload="handleLogobefore">
                        <img v-if="params.orgLogo" :src="params.orgLogo" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </div>
                    <div class="minitem">
                        <span class="label">所在省份</span>
                        <el-select v-model="params.province" placeholder="请选择" class="autowidth" clearable>
                            <el-option v-for="item in province" :key="item.dicKey" :label="item.cDicValue" :value="item.cDicValue"></el-option>
                        </el-select>
                    </div>
                    <div class="minitem">
                        <span class="label">执业年份</span>
                        <el-input v-model="params.practicingTime" placeholder="请输入执业年份" class="autowidth" clearable maxlength="10" show-word-limit>
                            <template slot="append">年</template>
                        </el-input>
                    </div>
                    <div class="minitem">
                        <span class="label">机构人数</span>
                        <el-input v-model="params.registerNumber" placeholder="请输入机构人数" class="autowidth" clearable maxlength="10" show-word-limit></el-input>
                    </div>
                    <div class="minitem">
                        <span class="label">单位地址</span>
                        <el-input v-model="params.address" placeholder="请输入单位地址" class="autowidth" clearable maxlength="50" show-word-limit></el-input>
                    </div>
                    <div class="minitem">
                        <span class="label">法人姓名</span> 
                        <el-input v-model="params.corporateName" placeholder="请输入法人姓名" class="autowidth" clearable maxlength="10" show-word-limit></el-input>
                    </div>
                    <div class="minitem">
                        <span class="label">法人身份证号</span>
                        <el-input v-model="params.corporateIdCard" placeholder="请输入法人身份证号" class="autowidth" clearable maxlength="18" show-word-limit></el-input>
                    </div>
                    <div class="minitem">
                        <span class="label">法人手机号</span>
                        <el-input v-model="params.contactTel" placeholder="请输入法人手机号" class="autowidth" clearable maxlength="11" show-word-limit></el-input>
                    </div>
                    <div class="minitem">
                        <span class="label">服务宗旨</span>
                        <el-input type="textarea" v-model="params.remark" placeholder="请填写服务宗旨" class="autowidth" clearable maxlength="200" show-word-limit></el-input>
                    </div>
                </div>
            </div>

            <div class="item">
                <p class="mintitle">机构代码</p>
                <div class="content">
                    <div class="minitem">
                        <el-radio-group v-model="params.idType">
                            <el-radio :label="1">营业执照</el-radio>
                            <el-radio :label="2">组织机构代码证</el-radio>
                            <el-radio :label="0">其他</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="minitem">
                        <span class="label">营业执照编号</span>
                        <el-input v-model="params.licenseNumber" placeholder="请输入营业执照编号" class="autowidth" clearable maxlength="30" show-word-limit></el-input>
                    </div>
                    <div class="minitem" style="display: flex;">
                        <span class="label">营业执照</span>
                        <el-upload
                            class="upload-demo"
                            drag
                            :action="actionUrl"
                            :headers="{Authorization:Authorization}"
                            multiple
                            :limit="1"
                            :on-success="handlelicenseSuccess"
                            name="images"
                            :on-remove="handlelicenseremove"
                            >
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
                        </el-upload>
                    </div>
                    
                </div>
            </div>

            <div class="item">
                <p class="mintitle">行业资质（选填）</p>
                <div class="content">
                    <div class="minitem" style="display: flex;">
                        <span class="label">行业资质</span>
                        <el-upload
                            class="upload-demo"
                            drag
                            :action="actionUrl"
                            :headers="{Authorization:Authorization}"
                            multiple
                            :on-success="handqualificationsSuccess"
                            :on-remove="handleremove"
                            name="images">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
                        </el-upload>
                    </div>
                </div>
            </div>

            <div class="footer_btn">
                <el-button @click="$router.go(-1)">返回</el-button>
                <el-button type="primary" @click="submit()">提交</el-button>
            </div>
        </div>
        
    </div>
</template>
<script>
export default{
    data() {
        return {
            actionUrl:process.env.VUE_APP_URL+'AppUser/UpdatePortraitAndCertificate',
            Authorization:sessionStorage.getItem('Authorization'),
            logoing:false,
            province:[],
            params:{
                orgName: "",//机构名称
                orgLogo: "",//机构图标地址
                address: "",//通讯地址
                province: "",//省
                corporateName: "",//法人姓名
                corporateIdCard: "",//法人身份证号
                idType: 1,//证件类型(0:其他、1：营业执照、2：组织机构代码证)
                licenseNumber: "",//执照编号(机构代码)
                licenseUrl: "",//执照url地址
                qualifications:[],//行业资质（url地址）
                remark:'',
                contactTel:'',
                practicingTime:'',
                registerNumber:''
            }
        }
    },
    mounted() {
        this.dictionaryLevelPage()
    },
    methods: {
        // 获取省份数据字典
        dictionaryLevelPage(){
            this.$Http_Post('/User/GetDictionaryList',{DicTypCode:'24'}).then(res=>{
                if(res.Code==0 || res.Code==200){
                    this.province=res.Data;
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        // 上传logo
        handleLogoSuccess(file){
            this.logoing=false;
            this.params.orgLogo=file.Data;
        },
        handleLogobefore(){
            this.logoing=true;
        },
        // 营业执照上传成功
        handlelicenseSuccess(file){
            this.params.licenseUrl=file.Data;
        },
        handlelicenseremove(file,filelist){
            this.params.licenseUrl=filelist;
        },
        handqualificationsSuccess(file){
            this.params.qualifications.push(file.Data);
        },
        handleremove(file,filelist){
            this.params.qualifications=filelist;
        },

        submit(){
            this.$Http_Post('/basic/Organization/add',this.params).then(res=>{
                if(res.Code==0 || res.Code==200){
                    this.params=this.$options.data().params;
                    this.$message.success(res.Message);
                }else{
                    this.$message.error(res.Message);
                }
            })
        }
        
    },
}
</script>
<style scoped>
.institutionalaccreditation{background: #fff;padding: 40px 0;}
.institutionalaccreditation .MainContent{width: 960px;margin: auto;}
.institutionalaccreditation .MainContent .title{font-size: 24px;margin-bottom: 20px;}
.institutionalaccreditation .MainContent .item{margin-bottom: 15px;}
.institutionalaccreditation .MainContent .item .mintitle{background: #F2F2F2;padding: 8px 20px;}
.institutionalaccreditation .MainContent .item .content{width: 350px;margin: auto;}
.institutionalaccreditation .MainContent .item .content .minitem{margin-top: 15px;}
.institutionalaccreditation .MainContent .item .content .minitem span{width: 100px;display: inline-block;}
.institutionalaccreditation .autowidth{width: 240px;}
.avatar-uploader{display: inline-block;}
.avatar-uploader .el-upload {border: 1px dashed #d9d9d9;border-radius: 6px;cursor: pointer;position: relative;overflow: hidden;}
.avatar-uploader .el-upload:hover{border-color: #409EFF;}
.avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 148px;height: 148px;line-height: 148px;text-align: center;background:#FAFAFA;}
.avatar {width: 148px;height: 148px;display: block;}
.upload-demo{width: 240px;}
.footer_btn{text-align: right;margin-top: 50px;}

</style>